export default [
  require('src/assets/images/location/map/gh-map-high-street.png'),
  require('src/assets/images/location/map/gh-map-enjoyment.png'),
  require('src/assets/images/location/map/gh-map-greenspace.png'),
  require('src/assets/images/location/map/gh-map-education.png'),
];
